export default function (url, width, height, type = 'crop') {
    if (type !== 'crop' && type !== 'resize') return url;

    if (!url) return null;

    if (!Number.isInteger(width) || !Number.isInteger(height)) return url;

    const index = url.indexOf('/uploads');

    if (index <= 0) return url;

    const base = url.substr(0, index);
    const path = url.substr(index + 1);

    return `${base}/images/${type}/${width}x${height}/${path}`;
}